"use client";

import { Card, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";

import FullLogoPrimary from "@/assets/logos/full-logo-secondary.png";
import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { PrivacyPolicyMessages } from "@/messages/privacy/privacy.messages";
import Footer from "@/mui/Footer";

import { Section } from "./components/Section";

type PrivacyProps = {
  messages: PrivacyPolicyMessages;
};

export default function PrivacyPolicy({ messages }: PrivacyProps) {
  const {
    title,
    introductionTitle,
    introduction,
    sectionsTitles,
    dataCollectionDetails,
    dataUsageDetails,
    dataSharingDetails,
    dataSubjectRightsDetails,
    securityInformationDetails,
    policyUpdatesDetails,
    applicableLegislationDetails,
  } = messages;

  const {
    margins: { xl },
  } = useTheme();

  const logoWidth = 220;
  const logoHeight = xl;

  return (
    <Grid container justifyContent="center" alignItems="center" height="100%">
      <Grid size={8}>
        <MDBox my={6}>
          <Card>
            <MDBox p={4} maxWidth="1000px" mx="auto">
              <MDBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
                py={4}
              >
                <img
                  src={FullLogoPrimary}
                  width={logoWidth}
                  height={logoHeight}
                  alt="Talk2Buy logo"
                />

                <MDTypography
                  variant="subtitle2"
                  fontWeight="bold"
                  textTransform="uppercase"
                  sx={{ textAlign: "center" }}
                  mt={5}
                >
                  {title}
                </MDTypography>
              </MDBox>
              <Section title={introductionTitle} description={introduction} />
              <Section description={sectionsTitles} />
              <Section description={dataCollectionDetails} />
              <Section description={dataUsageDetails} />
              <Section description={dataSharingDetails} />
              <Section description={dataSubjectRightsDetails} />
              <Section description={securityInformationDetails} />
              <Section description={policyUpdatesDetails} />{" "}
              <Section description={applicableLegislationDetails} />
            </MDBox>
          </Card>
          <Footer messages={messages} />
        </MDBox>
      </Grid>
    </Grid>
  );
}
